import { API, graphqlOperation } from 'aws-amplify';
import { DocumentNode } from 'graphql';
import React from 'react';

const useMutation = <MutationInput, MutationResult extends {}>(
  mutation: DocumentNode | string
  // mutation: DocumentNode | String
) => {
  const [data, setData] = React.useState<object | undefined>(undefined);

  const callMutation = React.useCallback(
    (input: MutationInput): Promise<{ data: MutationResult }> =>
      (
        API.graphql(graphqlOperation(mutation, { input })) as Promise<{
          data: MutationResult;
        }>
      ).then(response => {
        setData(response.data);
        return response;
      }),
    [mutation]
  );

  return { data, callMutation };
};

export default useMutation;
